import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]


export default {
  __name: 'SidebarMenuItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
  isYellow: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      href: '#' + __props.item.id,
      class: _normalizeClass(__props.isYellow ? 'link-yellow' : '')
    }, _toDisplayString(__props.item.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_1)
  ]))
}
}

}